import React, { FunctionComponent, useContext } from "react";
import { AppStore } from "../../app/store";
import { FocusableHeader, StateSelector } from "../../components";
import { useQueryParams, useTranslate } from "../../helpers";
import { linkToPaceInfo } from "../../helpers/CONSTANTS";
import { RouteComponentProps, withRouter } from "react-router";
import { AnalyticsActionType } from "../../app/contexts/Analytics/types";

const PaceLandingPage: FunctionComponent<RouteComponentProps> = ({
  location,
  history,
  match,
}) => {
  const t = useTranslate();
  const {
    state: { language },
    dispatch,
  } = useContext(AppStore.AppContext);
  useQueryParams({ location, history, match });

  return (
    <div className="PaceLandingPage">
      <div className="PaceLandingPage__hero">
        <div className="PaceLandingPage__heroContent">
          <FocusableHeader
            className="PaceLandingPage__heroHeader"
            text={t("pace.landing.header")}
            ignoreFocus={false}
          />
          <div className="ds-u-measure--wide mct-p1 ds-u-color--white ds-u-text-align--center ds-u-margin-top--2 ds-u-margin-bottom--7">
            {t("pace.landing.subheader")}
          </div>
        </div>
      </div>

      <div className="PaceLandingPage__content">
        <div className="PaceLandingPage__card">
          <StateSelector
            buttonText={t("pace.state_selector.button_text")}
            defaultLabel={t("pace.state_selector.select_state")}
            programType="PACE"
          />
          <p>
            {t("pace.landing.state_disclaimer")}{" "}
            <a
              href={linkToPaceInfo(language)}
              target="_blank"
              rel="noopener noreferrer"
              onClick={() => {
                dispatch({
                  type: AnalyticsActionType.SEND_TEALIUM_EVENT,
                  settings: {
                    event_action: "Internal Link Click",
                    event_label: `Learn more about PACE:${linkToPaceInfo(
                      language
                    )}`,
                    other_props: { event_category: "PACE" },
                  },
                });
              }}
            >
              {t("pace.landing.learn_more")}
            </a>
          </p>
        </div>
      </div>
    </div>
  );
};

export default withRouter(PaceLandingPage);
